// extracted by mini-css-extract-plugin
module.exports = {"sub":"k_1Vgnz","subscribe":"k_1PGbb","select":"k_1pwnO","selected":"k_1giQY","price":"k_1gKGv","notice":"k_3pWOM","error":"k_3qbK4"};